/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RankResult
 */
export interface RankResult {
    /**
     * 
     * @type {string}
     * @memberof RankResult
     */
    rank?: string;
    /**
     * 
     * @type {string}
     * @memberof RankResult
     */
    id?: string;
}

/**
 * Check if a given object implements the RankResult interface.
 */
export function instanceOfRankResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RankResultFromJSON(json: any): RankResult {
    return RankResultFromJSONTyped(json, false);
}

export function RankResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RankResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function RankResultToJSON(value?: RankResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rank': value.rank,
        'id': value.id,
    };
}

